import { makeStyles } from "@material-ui/core/styles";
import { Backdrop, Button, Fade, Modal } from "@material-ui/core";
import { formatDate } from "../../utils/date";

const useStyles = makeStyles(() => ({
  tableContainer: {
    border: "2px solid black",
    borderRadius: "10px",
  },
  uploadBtn: {
    backgroundColor: "#5CE0D2",
    borderRadius: "27px",
    textTransform: "none",
    fontWeight: "bold",
  },
  viewBtn: {
    backgroundColor: "#4CAF50",
    color: "#fff",
    textTransform: "none",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalBox: {
    background: "#fff",
    padding: "20px",
    borderRadius: "12px",
    width: "80%",
    maxWidth: "750px",
    outline: "none",
  },
  modalActions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "15px",
  },
}));

export function SubmissionPreviewModal({
  task,
  submission,
  onDelete,
  onClose,
  deleting,
  isDeadlinePassed,
  openModal
}) {
  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={openModal}
      onClose={() => !deleting && onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={openModal}>
        <div className={classes.modalBox}>
          <h2 style={{ marginBottom: "15px" }}>Submission Details</h2>

          {/* 📊 INFO CARD */}
          <div
            style={{
              background: "#f9fafb",
              padding: "15px",
              borderRadius: "10px",
              marginBottom: "15px",
              border: "1px solid #eee",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <span style={{ color: "#666" }}>Submitted At</span>
              <strong>{formatDate(submission?.submittedAt)}</strong>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <span style={{ color: "#666" }}>Deadline</span>
              <strong>{formatDate(task?.to)}</strong>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: "#666" }}>Status</span>

              {submission?.submitStatus === "submitted late" ? (
                <span
                  style={{
                    background: "#fff4e5",
                    color: "#ff9800",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  Late Submission
                </span>
              ) : (
                <span
                  style={{
                    background: "#e8f5e9",
                    color: "#4caf50",
                    padding: "4px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 600,
                  }}
                >
                  Submitted On Time
                </span>
              )}
            </div>
          </div>

          {/* 📄 FILE PREVIEW CARD */}
          <div
            style={{
              border: "1px solid #eee",
              borderRadius: "10px",
              overflow: "hidden",
              marginBottom: "10px",
            }}
          >
            {submission?.resources?.[0]?.fileUrl ? (
              <iframe
                src={submission.resources[0].fileUrl}
                title="submission"
                width="100%"
                height="400px"
                style={{ border: "none" }}
              />
            ) : (
              <div
                style={{ padding: "20px", textAlign: "center", color: "#777" }}
              >
                No preview available
              </div>
            )}
          </div>

          {/* ⚠️ DEADLINE MESSAGE */}
          {isDeadlinePassed && (
            <div
              style={{
                background: "#fdecea",
                color: "#d32f2f",
                padding: "10px",
                borderRadius: "8px",
                fontSize: "13px",
                marginBottom: "10px",
              }}
            >
              Submissions cannot be removed after the deadline has passed.
            </div>
          )}

          {/* 🎯 ACTIONS */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "15px",
            }}
          >
            <Button variant="outlined" onClick={onClose} disabled={deleting}>
              Close
            </Button>

            <Button
              variant="contained"
              color="secondary"
              disabled={deleting || isDeadlinePassed}
              onClick={onDelete}
            >
              {isDeadlinePassed
                ? "Deadline Passed"
                : deleting
                ? "Deleting..."
                : "Delete Submission"}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
